////////////////////////////////////////////////////////////////////////////////////////////////
// joints_native
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.joints_native = function ( ) {
	    
		/*
		These functions make sure WordPress
		and Foundation play nice together.
		*/    

		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();
		
		 // Makes sure last grid item floats left
		$('.archive-grid .columns').last().addClass( 'end' );
		
		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
			if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			  $(this).wrap("<div class='widescreen flex-video'/>");
			} else {
			  $(this).wrap("<div class='flex-video'/>");
			}
		});
	
    };
})( jQuery );

////////////////////////////////////////////////////////////////////////////////////////////////
// client_scripts_functionality
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_scripts_functionality = function ( ) {
	    
	    // exec
	    eraseCookie('ff_cpt_faq');
	    
	    non_internal_links_in_new_window();
	    
	    adding_tooltip_to_links();
	    
	    remove_empty_paragraphs(); 


		/**
		 * @desc
		 * @return (Void)
		 */
		function createCookie(name,value,days) {
		    var expires = "";
		    if (days) {
		        var date = new Date();
		        date.setTime(date.getTime()+(days*24*60*60*1000));
		        expires = "; expires="+date.toGMTString();
		    }
		    document.cookie = name+"="+value+expires+"; path=/";
		}
		
		/*
		function readCookie(name) {
		    var nameEQ = name + "=";
		    var ca = document.cookie.split(';');
		    for(var i=0;i < ca.length;i++) {
		        var c = ca[i];
		        while (c.charAt(0)==' ') c = c.substring(1,c.length);
		        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		    }
		    return null;
		}
		*/

		/**
		 * @desc
		 * @return (Void)
		 */
		function eraseCookie(name) {
		    createCookie(name,"",-1);
		}
		
		
		/**
		 * @desc Opening non-internal links in _blank (https://css-tricks.com/snippets/$/open-external-links-in-new-window/)
		 * @return (Void)
		 */
		function non_internal_links_in_new_window(){
			$('a').each(function() {
			   var a = new RegExp('/' + window.location.host + '/');
			   if(!a.test(this.href)) {
			       $(this).click(function(event) {
			           event.preventDefault();
			           event.stopPropagation();
			           window.open(this.href, '_blank');
			       });
			   }
			});			
		}

		/**
		 * @desc Adding tooltips to links ( @todo merge this with the snippet above - just simply look for closest parent...?)
		 * @return (Void)
		 */
		function adding_tooltip_to_links() {
			$('#inner-content a').each(function() {
			   var a = new RegExp('/' + window.location.host + '/');
			   var b = this.href;
			   var tooltip_text = 'Lenken åpnes i ny fane';
			
			   /* checking to see if external link and is not a button */
			   if(!a.test(this.href) && !$(this).hasClass("button")) {
			
			        /* checking to see if starting with "http", since "mailto:" and "tel:" is also picked up at this point */
			        if (b.match("^http")) {
			            new Foundation.Tooltip($(this), {
			                tipText: tooltip_text,
			            });
			        }
			   }
			});			
		}

		
		/*
		 * @description Remove empty paragraph tags
		 *
		 */
		function remove_empty_paragraphs() {
			$('p').each(function(index, item) {
			    if($.trim($(item).text()) === "") {
			        $(item).remove();
			    }
			});	
		}

	
    };  
})( jQuery );

////////////////////////////////////////////////////////////////////////////////////////////////
// client_scripts_visual
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_scripts_visual = function ( ) {	    
		
		// exec
		footer_logos();
		add_min_height_to_directors();
		director_reflow();
		ld_button_group_small_screen_adjustment( 'ff_button_group', 'button', 374 );
		smooth_scrolling();
		
		/**
		 * @desc Smooth Scrolling (https://css-tricks.com/snippets/$/smooth-scrolling/)
		 * @return (Void)
		 */
		function smooth_scrolling() {
			$('a[href*="#"]:not([href="#"])').click(function() {
				if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
					if (target.length) {
						$('html, body').animate({
							scrollTop: target.offset().top
						}, 200);
						return false;
					}
				}
			});
		}
		
		
		/**
		 * @desc Footer logos
		 * @return (Void)
		 */
		function footer_logos(){
		    var pl_wapper_width = $( '.partnerLogoW:visible' ).width(); // since this is outputted two times in markup we need to check :visible
		    var number_of_partners = $( ".partnerLogoW a:visible" ).length; // since this is outputted two times in markup we need to check :visible
		
		
		    var margin_horizontal = 34;
		    var not_available_space = ((margin_horizontal * (number_of_partners -1)));
		    var each_width_calculated = (pl_wapper_width - not_available_space) / number_of_partners;
		
		    var each_width = 180;
		    if (each_width_calculated < 180) { // hack: preventing very big logos
		        each_width = each_width_calculated;
		    }
		
		    var each_height = each_width * 0.55;
		
		    $( '.partnerLogoLink' ).css('max-height', each_height);
		
		    var $partnerLogo = $('.partnerLogo:visible');
		    var len = $partnerLogo.length;
		    $partnerLogo.each(function(index, element) {
		        var $this = $(this);
		        $this.css('max-height', each_height);
		        $this.css('max-width', each_width - 10);
		        /* no margin right for last item */
		        if (index != len - 1) {
		            $this.css('margin-right', margin_horizontal);
		        }
		    });
		
		    $( '.partnerLogoW' ).animate({ opacity: 1 });
		}
		

		

		
		
		/**
		 * @desc Add minimum height for directors to prevent overlapping on small screens due to absolute positioning
		 * @return (Void)
		 */
		function add_min_height_to_directors() {
		
			var director = $('.directorColumn');
			
			$.each( director, function() {
				var height_director_details = $(this).find('.js_director_details .valign').height();
				var height_director_details_wrapper = $(this).find('.js_director_details');
				var directors_image = $(this).find('.js_director_image');
				
				directors_image.css('min-height', height_director_details);
				height_director_details_wrapper.css('min-height', height_director_details);
			});
		
		}
		
		/**
		 * @description Reflow foundation equalizer
		 * @param {String} el Class name
		 * @return {Void}
		 */
		function ld_foundation_equalizer_reflow( $obj ) {
			
		    var ld_eq = new Foundation.Equalizer( $obj );
		    ld_eq.applyHeight();
		
		}
		
		/**
		 * @desc Reflowing the column height for the directors
		 * @return (Void)
		 */
		function director_reflow(){
			if ($('.directorRow').length) {
				ld_foundation_equalizer_reflow($('.directorRow'));
				$.ld_debug('dirrow');
			}	
		}
		
		/**
		 * @desc Adding expaned for buttons on certain screen size 
		 * @param (String) button_group_class_name Class name of the buttons wrapper
		 * @param (String) button_class_name Class name of the buttons
		 * @param (Int) screen_size What screensize the expaned buttons should be added
		 * @return Void
		 */
		function ld_button_group_small_screen_adjustment( button_group_class_name, button_class_name, screen_size ) {
			$.ld_debug('ld_button_group_small_screen_adjustment fired');
			
			var w_width = $(window).width(); 
			var button_group = $('.' + button_group_class_name );
			
			if ( w_width < screen_size ) { // 375px is iphone 6 width
				
				$.each( button_group, function() {
					$( this ).find( '.' + button_class_name ).addClass( 'expanded' );
					$( this ).find( '.' + button_class_name ).first().css( "margin-bottom", "8px" );
					$( this ).find( '.' + button_class_name ).css( 'margin-left', '0' );	
				});
				
			} else { // Wider than 375 px, so reset
				
				$.each( button_group, function() {
					$( this ).find( '.' + button_class_name ).removeClass( 'expanded' );
					$( this ).find( '.' + button_class_name ).prop( "style", null );
				});
				
			}
		}


	
    };
})( jQuery );


////////////////////////////////////////////////////////////////////////////////////////////////
// client_scripts_events
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.client_scripts_user_events = function ( ) {
	    
	    bindRevealEvents();	    
		
		/**
		 * @desc Bind handlers to the relevant Foundation events
		 * @return (Void)
		 */
		function bindRevealEvents() {
		    $(window).on(
		        'open.zf.reveal', function () {
		            reposition_modal_content('#menuModal .menu');
		            reposition_modal_content('.searchFormW');
		            
		            
					// make sure “search button” is the same height as the search field (search modal).
					// @todo make sure cursor is in the search input field when the modal is opened. 
					var searchHeight = $('.search-field').outerHeight();
					$('.search-submit').css('height', searchHeight);
		            
		            // Put focus on the search field when opening the modal
		            $( ".searchFormW .search-field" ).focus();
		
		        }
		    );
		}
		
		/**
		 * @desc Mobile menu modal
		 * @param (String) el
		 * @return (Void)
		 */
		function reposition_modal_content( el ) {
		    var window_height = $( window ).height();
		    var menu = $( el );
		    var menu_height = menu.height();
		    var padding_top = (window_height - menu_height) / 2;
		
			menu.css('padding-top', padding_top);
		}
	
    };
})( jQuery );